import React from 'react';
import 'twin.macro';
import { Field, useField } from 'react-final-form';
import { changeStartEndBasedFromDate } from 'containers/CahierJournal/EventModal/ModalBody/utils';
import TimepickerComponent from '@teetsh/app/src/components/Form/TimePicker2/formWrapper';
import { getDurationInHoursAndMinutesBetween } from '@teetsh/app/src/utils/time';
import SchoolDateInput from '@teetsh/app/src/components/Form/Dateinput2/SchoolDateInput';
import { useTranslation } from 'react-i18next';
import { UserLocale } from '@teetsh/app/src/types/user';

interface Props {
  sundayStart: boolean;
  valid: boolean;
  disableStartEnd?: boolean;
}

export function StartEndAndType(props: Props) {
  const { valid, sundayStart, disableStartEnd } = props;
  const startField = useField('start');
  const endField = useField('end');
  const start = startField.input.value;
  const end = endField.input.value;
  const { t } = useTranslation(['common', 'cahierJournal']);
  return (
    <div tw="flex justify-between">
      <div tw="w-full">
        <div tw="grid grid-cols-3 gap-2">
          {!disableStartEnd && (
            <>
              <div data-testid="start-hour">
                <Field
                  id="start"
                  label={`${t('common:labels.start')}*`}
                  name="start"
                  component={TimepickerComponent}
                />
              </div>
              <div data-testid="end-hour">
                <Field
                  label={`${t('common:labels.end')}*`}
                  helperText={
                    valid
                      ? t('cahierJournal:seance.modal.lasting', {
                          duration: getDurationInHoursAndMinutesBetween(
                            start,
                            end,
                          ),
                        })
                      : ''
                  }
                  name="end"
                  id="end"
                  min={start}
                  component={TimepickerComponent}
                  withoutMargin
                />
              </div>
            </>
          )}
          <div>
            <SchoolDateInput
              userLocale={t('common:locale.long') as UserLocale}
              id="date"
              label={`${t('common:labels.date')}*`}
              sundayStart={sundayStart}
              disabledDays={[0, 1, 2, 3]}
              value={start}
              onChange={date => {
                if (date) {
                  const { start: newStart, end: newEnd } =
                    changeStartEndBasedFromDate({
                      date,
                      start,
                      end,
                    });
                  startField.input.onChange(newStart);
                  endField.input.onChange(newEnd);
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
